import type { QueryClient } from '@tanstack/react-query';

import { citationRequestsQueryKey } from './queryOptions';
import { type CitationRequest, mergeCitationRequest } from '../model/citationRequest';

/**
 * Writes to a conversation's cached citation requests, so the hooks patch
 * one key one way. Reads go through the query options.
 */
export function putCitationRequest(
  queryClient: QueryClient,
  conversationId: string,
  request: CitationRequest
) {
  queryClient.setQueryData<CitationRequest[]>(
    citationRequestsQueryKey(conversationId),
    (previous) => mergeCitationRequest(previous, request)
  );
}

/** Replaces a request already in the list; a list without it is left alone. */
export function replaceCitationRequest(
  queryClient: QueryClient,
  conversationId: string,
  request: CitationRequest
) {
  queryClient.setQueryData<CitationRequest[]>(
    citationRequestsQueryKey(conversationId),
    (previous) => previous?.map((entry) => (entry.id === request.id ? request : entry))
  );
}

export function refetchCitationRequests(queryClient: QueryClient, conversationId: string) {
  return queryClient.invalidateQueries({ queryKey: citationRequestsQueryKey(conversationId) });
}
